<template>
    <v-container>
      <v-row>
        <!-- Product details -->
        <!-- <v-col cols="12" sm="6" order-sm="2"> -->
        <v-col cols="12" sm="6" offset-sm="1" md="4" offset-md="2" v-if="product">
          <v-card class="pb-2">
            <div class="pa-2">
              <v-img height="250px" width="auto" :src="product.imageUrl" aspect-ratio="2" contain>
              </v-img>
            </div>
            <v-card-title class="mt-0 pt-0" primary-title>
              <p v-html="product.title"></p>
            </v-card-title>
            <p class="ml-4"> Price: <span class="font-weight-bold ">{{product.price}} ZK</span><span>/{{product.unit}}</span></p>
            <p class="ml-4"> Description: <span v-html="product.description"></span></p>
            <p class="ml-4"> Location: <b> {{product.district}} district </b></p>
            <FavoriteBtn :product="product"/>
          </v-card>
        </v-col>
        <!-- Supplier details -->
        <v-col cols="12" sm="4" md="4" v-if="supplierInfo">
          <v-card class="pb-2">
            <v-card-title primary-title>
              Contact Supplier
            </v-card-title>
            <p class="ml-4">Phone Number: <b> {{supplierInfo.phoneNumber}} </b></p>
            <p class="ml-4" v-if="supplierInfo.type == 'business'">Company: <b> {{supplierInfo.companyName}} </b></p>
          </v-card>
          <v-card class="mt-3"  v-if="iscontacted">
            <v-card-text>
              <p class="primary--text">Your message has been sent to the supplier !</p>
              <p>Remember to check your inbox to see if you've received a reply.</p>
            </v-card-text>
          </v-card>
          <v-card  v-else class="mt-3">
              <v-card-title primary-title>
                Send a message to the supplier
              </v-card-title>
            <v-container>
              <v-form lazy-validation ref="form" v-model="valid" @submit.prevent="sendMessage">
                <v-textarea color="farmer_green" name="Message" :rules="messageRules" type="text" filled label="Message" v-model="message" counter="500" required></v-textarea>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn v-if="user" large class="white--text primary" :disabled="loading" :loading="loading" type="submit" value="send">Send</v-btn>
                  <NotAuthContactSupplierDialog v-else/>
                </v-card-actions>
              </v-form>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import { store } from '@/store'
import { mapGetters } from 'vuex'

export default {
  props: ['id'],
  data() {
    return {
      supplierInfo: null,
      message: '',
      loading: false,
      valid: true
    }
  },
  components: {
    FavoriteBtn: () => import('@/components/product/FavoriteBtn'),
    NotAuthContactSupplierDialog: () => import('@/components/product/NotAuthContactSupplierDialog')
  },
  computed: {
    ...mapGetters(['user', 'contactedProductsIds']),
    product() {
      return store.getters.productById(this.id)
    },
    messageRules() {
      return [field => field.length <= 500 || 'Max 500 characters']
    },
    iscontacted() {
      return this.contactedProductsIds.includes(this.id)
    }
  },
  watch: {
    product(val) {
      this.getSupplierInfo(val)
    }
  },

  methods: {
    getSupplierInfo(product) {
      this.supplierInfo = store.getters.supplierById(product.supplierId)
      if (!this.supplierInfo) {
        const supplier = {
          id: product.supplierId,
          type: product.supplierType
        }
        store.dispatch('fetchSupplierInfo', supplier)
          .then(data => {
            this.supplierInfo = data
          })
      }
    },
    sendMessage() {
      if (this.$refs.form.validate()) {
        this.isLoading = true
        const payload = {
          message: this.text2HTML(this.message),
          supplierInfo: this.supplierInfo,
          product: {
            id: this.id,
            title: this.product.title
          },
          customer: {
            firstName: this.user.firstName,
            email: this.user.email
          }
        }
        store.dispatch('sendMessageToSupplier', payload)
          .then(() => {
            this.isLoading = false
          })
      }
    },
    //  Helper function for text to HTML conversion
    text2HTML(text) {
      // 1: Plain Text Search
      var newxText = text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')

      // 2: Line Breaks
      newxText = newxText.replace(/\r\n?|\n/g, '<br>')

      // 3: Paragraphs
      newxText = newxText.replace(/<br>\s*<br>/g, '</p><p>')

      // 4: Wrap in Paragraph Tags
      newxText = '<p>' + newxText + '</p>'

      return newxText
    }
  },

  mounted() {
    if (this.product) {
      this.getSupplierInfo(this.product)
    }

    if (this.user && this.product) {
      this.message = `Hello,

I am ${this.user.firstName} and I'm interested in "${this.product.title}". 

I would like to get in contact so that we can discuss more about this product and see how we could proceed from here.

You can contact me back through this email: ${this.user.email}.

Thanks, I look forward to hearing back from you!`
    }
  }
}
</script>
